<template>
  <div></div>
</template>
<script>
import axios from "axios"
import helpers from "@/helpers"
import imgToBase64 from "image-to-base64"
import { baseApiUrl } from "@/global"
import pdfmake from "pdfmake"
import pdffonts from "pdfmake/build/vfs_fonts.js"

export default {
  data() {
    return {
      idQuote: null,
      quoteData: {},
      dateNow: '',
      logoB64: '',
      products: [],
      valorTotalOfQuote: 0,
      quantidadeTotalOfQuote: 0,
    }
  },
  methods: {
    async generate(id) {
      this.initValues()
      this.helpers = helpers
      this.idQuote = id
      if (!pdfmake.vfs) {
        pdfmake.vfs = pdffonts.pdfMake.vfs;
      }
      const response = await axios.post(`${baseApiUrl}/quote/getQuoteByID`, { idQuote: this.idQuote });
      this.quoteData = response.data
      await this.fixVarsToTable()
      this.makePDF()
    },
    initValues() {
      this.products = []
      this.valorTotalOfQuote = 0
      this.quantidadeTotalOfQuote = 0
    },
    async fixVarsToTable() {
      let products = JSON.parse(this.quoteData.orcamentos.jsonProdutos)
      for (let product of products) {
        this.products.push([
          product.codigo,
          product.descricaoPTBR,
          product.marca,
          product.modelo,
          product.quantidade,
          this.helpers.moneyHelper.formatNumberToCurrency(product.valorUnitario),
          this.helpers.moneyHelper.formatNumberToCurrency(product.valorTotal)
        ])
        this.quantidadeTotalOfQuote += +(product.quantidade)
        this.valorTotalOfQuote += +(product.valorTotal)
      }
      this.products.push([
        { text: '', border: [false, false, false, false] },
        { text: '', border: [false, false, false, false] },
        { text: '', border: [false, false, false, false] },
        { text: '', border: [false, false, false, false] },
        {
          text: this.quantidadeTotalOfQuote,
          bold: true,
        },
        { text: '', border: [false, false, false, false] },
        {
          text: this.helpers.moneyHelper.formatNumberToCurrency(this.valorTotalOfQuote),
          bold: true,
        },
      ])

      this.dateNow = this.helpers.dateHelper.getDatePTBR()
      this.logoB64 = await imgToBase64(this.quoteData.empresa.logo)
      this.logoB64 = 'data:image/jpeg;base64,' + this.logoB64
      if (this.quoteData.orcamentos.tipoCobranca == 'Cartão de Crédito') {
        this.quoteData.orcamentos.opcaoPagamento += 'X'
      }
    },
    makePDF() {
      let docDefinition = {
        info: {
          title: `ORÇAMENTO - ${this.quoteData.clientes.razaoSocial}`,
        },
        header: {
          style: 'header',
          columns: [{
              image: this.logoB64,
              fit: [60, 60],
              width: 70,
              link: 'https://www.revestebem.com/',
            },
            {
              width: 400,
              stack: [
                { text: this.quoteData.empresa.razaoSocial },
                { text: `${this.quoteData.empresa.endereco} - ${this.quoteData.empresa.bairro}` },
                { text: `${this.quoteData.empresa.cidade}/${this.quoteData.empresa.estado} - ${this.quoteData.empresa.cep}` },
                { text: `financeiro@regnaparts.com.br - ${this.quoteData.empresa.telefone}` },
                { text: this.quoteData.empresa.cnpj }
              ],
            },
            {
              margin: [30, 15, 0, 0],
              width: 'auto',
              text: `N° ${this.idQuote}`,
              fontSize: 15
            }
          ],
          margin: [15, 10, 10, 0]
        },
        content: [
          { text: 'DESTINÁTARIO / REMETENTE', style: 'contentHeader' },
          {
            table: {
              widths: ['12.5%', '12.5%', '12.5%', '12.5%', '12.5%', '12.5%', '12.5%', '12.5%'],
              body: [
                [
                  { stack: [{ text: 'RAZÃO SOCIAL', bold: true }, this.quoteData.clientes.razaoSocial], colSpan: 5 },
                  [''],
                  [''],
                  [''],
                  [''],
                  { stack: [{ text: 'CPF/CNPJ', bold: true }, this.quoteData.clientes.cpfCnpj], colSpan: 2 },
                  [''],
                  [{ text: 'I.E.', bold: true }, this.quoteData.clientes.inscricaoEstadual],
                ],
                [
                  { stack: [{ text: 'ENDEREÇO', bold: true }, `${this.quoteData.clientes.endereco}, ${this.quoteData.clientes.numeroCasa} - ${this.quoteData.clientes.bairro} - ${this.quoteData.clientes.cidade}/${this.quoteData.clientes.estado} - ${this.quoteData.clientes.cep} `], colSpan: 7 },
                  [''],
                  [''],
                  [''],
                  [''],
                  [''],
                  [''],
                  [{ text: 'DATA EMISSÃO', bold: true }, this.dateNow],
                ],
                [
                  { stack: [{ text: 'EMAIL', bold: true }, this.quoteData.clientes.emailNFe], colSpan: 5 },
                  [''],
                  [''],
                  [''],
                  [''],
                  { stack: [{ text: 'FONE / CELULAR', bold: true }, this.quoteData.clientes.telefone], colSpan: 2 },
                  [''],
                  [{ text: 'VALIDADE', bold: true }, this.helpers.dateHelper.addDaysToDate(this.dateNow, 5)],
                ],
              ],
            },
          },
          { text: 'INFORMAÇÕES COMERCIAIS', style: 'contentHeader' },
          {
            table: {
              widths: ['50%', '50%'],
              body: [
                [
                  { stack: [{ text: 'REPRESENTANTE', bold: true }, this.quoteData.clientes.representante], colSpan: 2 },
                  [''],
                ],
                [
                  { stack: [{ text: 'CONDIÇÃO DE PAGAMENTO', bold: true }, this.quoteData.orcamentos.opcaoPagamento || '-'] },
                  { stack: [{ text: 'TIPO DE COBRANÇA', bold: true }, this.quoteData.orcamentos.tipoCobranca.toUpperCase()] }
                ],
              ]
            }
          },
          { text: 'PRODUTOS', style: 'contentHeader' },
          {
            table: {
              widths: ['auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto'],
              body: [
                [
                  { text: 'CÓDIGO', bold: true },
                  { text: 'DESCRIÇÃO', bold: true },
                  { text: 'MARCA', bold: true },
                  { text: 'MODELO', bold: true },
                  { text: 'QTD', bold: true },
                  { text: 'VLR UNIT', bold: true },
                  { text: 'VLR TOTAL', bold: true }
                ],
                ...this.products,
              ]
            },
          },
          { text: 'TRANSPORTADORA', style: 'contentHeader' },
          {
            table: {
              widths: ['12.5%', '12.5%', '12.5%', '12.5%', '12.5%', '12.5%', '12.5%', '12.5%'],
              body: [
                [
                  { stack: [{ text: 'NOME / RAZÃO SOCIAL', bold: true }, this.quoteData.transportadoras.razaoSocial], colSpan: 5 },
                  [''],
                  [''],
                  [''],
                  [''],
                  { stack: [{ text: 'CPF/CNPJ', bold: true }, this.quoteData.transportadoras.cpfCnpj], colSpan: 2 }, // mudar pra cnpj transportadora
                  [''],
                  [{ text: 'TIPO DE FRETE', bold: true }, this.quoteData.orcamentos.tipoFrete],
                ],
                [
                  { stack: [{ text: 'ENDEREÇO', bold: true }, this.quoteData.transportadoras.endereco + (this.quoteData.transportadoras.numeroCasa ? ', ' + this.quoteData.transportadoras.numeroCasa : '')], colSpan: 3 },
                  [''],
                  [''],
                  { stack: [{ text: 'MUNICÍPIO', bold: true }, this.quoteData.transportadoras.cidade] },
                  { stack: [{ text: 'BAIRRO / DISTRITO', bold: true }, this.quoteData.transportadoras.bairro], colSpan: 2 },
                  [''],
                  [{ text: 'UF', bold: true }, this.quoteData.transportadoras.estado],
                  [{ text: 'CEP', bold: true }, this.quoteData.transportadoras.cep],
                ],
                [
                  { stack: [{ text: 'FONE / CELULAR', bold: true }, this.quoteData.clientes.telefone], colSpan: 3 },
                  [''],
                  [''],
                  { stack: [{ text: 'VOLUMES', bold: true }, this.quoteData.orcamentos.volume], colSpan: 3 },
                  [''],
                  [''],
                  { stack: [{ text: 'VALOR DO FRETE', bold: true }, this.helpers.moneyHelper.formatNumberToCurrency(this.quoteData.orcamentos.valorFrete)], colSpan: 2 },
                  [''],
                ],
              ],
            },
          },
          { text: 'INFORMAÇÕES ADICIONAIS', style: 'contentHeader' },
          {
            table: {
              widths: ['*'],
              body: [
                [
                  [{ text: 'OBSERVAÇÕES', bold: true }, this.quoteData.orcamentos.observacoes.toUpperCase()]
                ]
              ]
            }
          }
        ],
        footer: function() {
          return {
            stack: [{ text: 'APROVAÇÃO', fontSize: 8, bold: true, color: '#595959' },
              {
                table: {
                  widths: ['auto', '*'],
                  body: [
                    ['', ''],
                    ['', ''],
                    ['', ''],
                    ['', ''],
                    ['DATA: ___/___/_______', 'ASSINATURA: ______________________________________________________________________________________________________________________'],
                  ],
                },
                layout: {
                  hLineColor: function(i, node) {
                    return (i === 0 || i === node.table.body.length) ? 'black' : 'white';
                  },
                  vLineColor: function(i, node) {
                    return (i === 0 || i === node.table.widths.length) ? 'black' : 'white';
                  },
                },
              }
            ],
            margin: [10, 0, 10, 0],
          }
        },
        styles: {
          contentHeader: {
            fontSize: 8,
            margin: [0, 15, 0, 0],
            bold: true,
            color: '#595959',
          },
          header: {
            fontSize: 9,
          }
        },
        defaultStyle: {
          fontSize: 8,
        },
        pageMargins: [10, 65, 10, 55]
      }
      pdfmake.createPdf(docDefinition).open()
    }
  },
}

</script>
